import { Component, Input, ViewChild, computed, signal } from "@angular/core"
import {
	ConfigDefinitions,
	ReportItemType,
	reportParamsObj,
	reportVisFields,
} from "@app/definitions/types"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import * as moment from "moment"
import { AvailablePostPaths, pluck } from "@app/services/api.service"
import { Modalable } from "@app/Modalable"

@Component({
	selector: "app-reports",
	templateUrl: "./reports.component.html",
})
export class ReportsComponent extends Modalable {
	modalWidth: string = "modal-full-width"
	reportVisFields = reportVisFields

	//each returned row MUST have item_id and item_type (patient/payor/contact)
	cliniqData: any = null
	sortField: string = null
	sortIsAsc: boolean = false
	//might change
	summarizedView: boolean = false
	showVis: boolean = false
	tableRows: any[] = []
	hasFuzzyFields: boolean = true
	areConditionalColumnsVisible: boolean = false //true when payment_method
	dateNeedFormatting: boolean = true
	periodInputs: any[] = [
		"this_year",
		"last_year",
		"this_month",
		"month_before",
		"two_months_before",
		"date_range",
	].map((it) => ({ name: it, value: it }))
	breakInputs = signal(["month", "year", "item", "payor", "no_breaks"])
	breakInputsMV = computed(() =>
		this.breakInputs().map((it) => {
			return {
				name:
					this.lang.translation[it == "item" ? this.itemFuzzy.lang : it] || it,
				value: it,
			}
		})
	)
	individualViews: string[] = ["individual", "group", "all_options"]
	paidByInvoiceModes: string[] = ["paid", "not_paid", "all_options"]
	curRow: any = null
	dates_range: boolean = true
	itemName: string = ""
	showByCreatedAt: any = "no"
	reportMode: any = "no"
	visFields: any = null

	@ViewChild("fromDate") fromDate: DatePickerComponent
	@ViewChild("toDate") toDate: DatePickerComponent

	reportParamsObj: reportParamsObj = new reportParamsObj()

	totals: any = { total: 0, vat: 0, totMinusVat: 0 }
	errors: any = {} //will hold errors for the fields in the form
	filterFieldName: string = ""
	filterFieldValue: number = 0
	filterFieldShown: string = ""
	item_type: ReportItemType = ""
	itemFuzzy: any = null

	fuzzyFields: any[] = [
		{
			fieldName: "item_id",
			lang: "item_name",
			collection: ["patients", "contacts", "payors"],
		},
		//{fieldName:'patienttype_id', lang: 'patienttype', collection: ['patienttypes']},

		// {fieldName:'payor_id', lang: 'payor', collection: 'payors'},
	]
	fields: any[] = []

	@Input() report_name: string = ""
	report_lang: string = ""
	apiCall: AvailablePostPaths
	inputRow: any = null
	vat_numbers: any[] = []
	is_new_vat_number: boolean = false

	isLoading: boolean = false
	hasBreakHeaders: boolean = false
	isSendingPdf: boolean = false
	invoice_per_followup: boolean = false
	curShowToken: string = null

	ngOnInit() {
		//when called to open
		this.cliniqData = this.store.getCliniqDataOrExit()

		this.reportParamsObj.showItemNumberAsName =
			this.cliniqData.show_numbers_not_names_on_reports
		console.log(this.reportParamsObj.showItemNumberAsName)

		this.invoice_per_followup =
			this.cliniqData.invoice_per_followup == "yes" ? true : false
		if (this.cliniqData.expenses_by_created_at_default == "yes") {
			this.showByCreatedAt = "yes"
		}

		if (this.cliniqData.is_new_vat_number == "yes") {
			this.is_new_vat_number = true
			this.vat_numbers = [
				{ id: "", name: this.lang.getVal("all_vat_numbers") },
				{
					id: this.cliniqData.old_vat_number,
					name: this.cliniqData.old_vat_number,
				},
				{ id: this.cliniqData.vat_number, name: this.cliniqData.vat_number },
			]
		}

		this.hasBreakHeaders = false
		this.itemFuzzy = this.fuzzyFields.find((it) => it.fieldName == "item_id")
		this.itemFuzzy.collection = ["patients", "contacts", "payors", "sub_users"]
		switch (this.report_name) {
			case "invoices_report":
				this.report_lang = "income_report"

				this.fields = [
					{ fieldName: "date", lang: "date", isDate: true },
					{ fieldName: "item_name", lang: "name" },
					{
						fieldName: "total",
						lang: "sum",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "vat",
						lang: "vat",
						totals: true,
						conditionalValue: false,
						isNumberField: true,
					},
					{
						fieldName: "totalMinusvat",
						lang: "totalMinusvat",
						totals: true,
						conditionalValue: false,
						isNumberField: true,
					},
					{ fieldName: "model_name", lang: "model_name" },
					{ lang: "finresource_num", actionType: "downloadInvoice" },
					{ fieldName: "paid_by_finresource", lang: "receipt", width: "10%" },
					{ lang: "email_invoice", actionType: "emailInvoice" },
					{
						fieldName: "sendgrid_status",
						lang: "sendgrid_status",
						actionType: "sendStatus",
					},
					{
						fieldName: "emails",
						lang: "sent_to",
						ngIfFunc: (reportParamsObj: reportParamsObj) => {
							return reportParamsObj?.showEmails
						},
					},
					{
						fieldName: "payment_method",
						lang: "payment_method",
						conditionalValue: true,
					},
					{
						fieldName: "cheque_num",
						lang: "cheque_num",
						conditionalValue: true,
					},
				]

				this.breakInputs.set(["month", "year", "item", "no_breaks"])
				this.apiCall = "get_invoice_report" //"get_invoiceList";
				this.dateNeedFormatting = false
				this.reportParamsObj.report_break_input = "no_breaks"
				// this.reportParamsObj.report_break_input="item";

				break
			case "invoices_report_by_payment_method":
				this.report_lang = "income_report_by_payment_method"
				this.fields = [
					{ fieldName: "date", lang: "date", isDate: true },
					{ fieldName: "repayment_date", lang: "repayment_date", isDate: true },
					{ lang: "finresource_num", actionType: "downloadInvoice" },
					{
						fieldName: "total",
						lang: "sum",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "item_name", lang: "name" },
					{ fieldName: "model_name", lang: "model_name" },
					{ lang: "email_invoice", actionType: "emailInvoice" },
					{ fieldName: "payment_method", lang: "payment_method" },
					{ fieldName: "cheque_num", lang: "cheque_num" },
				]
				this.breakInputs.set([
					"month",
					"year",
					"item",
					"payment_method",
					"no_breaks",
				])
				this.apiCall = "get_invoice_report_by_payment_method" //"get_invoiceList";
				this.dateNeedFormatting = false
				this.reportParamsObj.report_break_input = "payment_method"
				// this.reportParamsObj.report_break_input="item";

				break
			case "admininvoices_report":
				this.fuzzyFields = [
					{
						fieldName: "item_id",
						lang: "therapist",
						collection: ["all_users"],
					},
				]
				this.report_lang = "admin_income_report"
				this.fields = [
					{ fieldName: "date", lang: "date", isDate: true },
					{
						fieldName: "total",
						lang: "sum",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "vat",
						lang: "vat",
						totals: true,
						conditionalValue: false,
						isNumberField: true,
					},
					{
						fieldName: "totalMinusvat",
						lang: "totalMinusvat",
						totals: true,
						conditionalValue: false,
						isNumberField: true,
					},
					{ fieldName: "paid_by", lang: "paid_by" },
					{ lang: "invoice", actionType: "downloadInvoice" },
					{
						fieldName: "sendgrid_status",
						lang: "sendgrid_status",
						actionType: "sendStatus",
					},
					{ lang: "email_invoice", actionType: "emailInvoice" },
					{ lang: "credit_invoice_short", actionType: "creditInvoice" },
					{
						fieldName: "payment_method",
						lang: "payment_method",
						conditionalValue: true,
					},
				]
				this.breakInputs.set(["month", "year", "no_breaks"])
				this.apiCall = "get_admininvoices_report" //"get_invoiceList";
				this.dateNeedFormatting = false
				// this.reportParamsObj.report_break_input="item";

				break
			case "paying_customers_report":
				this.breakInputs.set([])
				this.periodInputs = []
				this.dates_range = false
				this.fuzzyFields = [
					{
						fieldName: "item_id",
						lang: "therapist",
						collection: ["all_users"],
					},
				]
				this.report_lang = "paying_customers_report"
				this.fields = [
					{
						fieldName: "id",
						lang: "id",
					},
					{ fieldName: "name", lang: "name" },
					{
						fieldName: "sum_withvat",
						lang: "total",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "sum",
						lang: "sum",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "paying_num",
						lang: "paying_num",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "sub_num_free",
						lang: "sub_num_free",
						totals: true,
						isNumberField: true,
					},
				]

				this.apiCall = "get_paying_customers_report"

				break
			case "followups_report":
				this.itemFuzzy.collection = ["patients"]
				this.itemFuzzy.lang = "patients"
				this.report_lang = "follow_ups_report"
				this.fields = [
					{ fieldName: "date", lang: "blank_value", isDate: true },
					{ fieldName: "item_name", lang: "name" },
					{ fieldName: "assoc", lang: "therapist" },
					{ fieldName: "arrived", lang: "arrived", actionType: "isCheckmark" },
					{
						fieldName: "meetingtype_name",
						lang: "meetingtype",
						totals: true,
						addFunc: (row: any) => row?.type == "followup",
					},
					// { fieldName: "group_name", lang: "group" },
					{
						fieldName: "price",
						lang: "charge",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "price_patient",
						lang: "price_patient",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "payor_name", lang: "payor" },
					{
						fieldName: "price_payor",
						lang: "price_payor",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "sub_user_tarif",
						lang: "sub_user_tarif",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "price_minus_sub_user_tarif",
						lang: "price_minus_sub_user_tarif",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "paid_by", lang: "paid_by" },
					{
						fieldName: "total",
						lang: "paid",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "vat", lang: "vat", totals: true, isNumberField: true },
					{ lang: "finresource_num", actionType: "downloadInvoice" },

					{ fieldName: "paid_by_invoice", lang: "paid_by_invoice" },
					{
						fieldName: "charged_manualy",
						lang: "charged_manualy",
						actionType: "isCheckmark",
					},
					{ lang: "email_invoice", actionType: "emailInvoice" },
					{
						fieldName: "sendgrid_status",
						lang: "sendgrid_status",
						actionType: "sendStatus",
					},

					/*{fieldName:'invoice_id', lang: 'charged_manualy'},*/
				]
				if (
					!this.permsService?.owner_has_users ||
					!this.permsService?.perms?.administrative
				) {
					this.fields = this.fields.filter((f) => f.fieldName != "assoc")
				}
				if (
					!this.permsService?.owner_has_users ||
					!this.permsService?.perms?.administrative
				) {
					this.fields = this.fields.filter(
						(f) => f.fieldName != "sub_user_tarif"
					)
					this.fields = this.fields.filter(
						(f) => f.fieldName != "price_minus_sub_user_tarif"
					)
				}
				this.fuzzyFields = [
					{ fieldName: "item_id", lang: "patient", collection: ["patients"] },
					{
						fieldName: "meetingtype_id",
						lang: "meetingtype",
						collection: ["meetingtypes"],
					},
					{
						fieldName: "sub_user_id",
						lang: "users",
						collection: ["sub_users"],
					},
				]
				if (
					!this.permsService?.owner_has_users ||
					!this.permsService?.perms?.administrative
				) {
					this.fuzzyFields = this.fuzzyFields.filter(
						(f) => f.fieldName != "sub_user_id"
					)
				}
				this.breakInputs.set([
					"month",
					"year",
					"item",
					"meetingtype",
					"no_breaks",
				])
				this.apiCall = "get_followups_report" //"get_followupList";
				break
			case "followups_text_report":
				this.hasBreakHeaders = true
				this.itemFuzzy.collection = ["patients"]
				this.itemFuzzy.lang = "patients"
				this.report_lang = "text_report"
				this.fields = [
					{
						fieldName: "date",
						lang: "blank_value",
						width: "10%",
						isDate: true,
					},
					{ fieldName: "item_name", lang: "name", width: "20%" },
					{ fieldName: "assoc", lang: "therapist" },
					{ fieldName: "meetingtype_name", lang: "meetingtype", width: "10%" },
					{
						fieldName: "arrived",
						lang: "arrived",
						width: "5%",
						actionType: "isCheckmark",
					},
					{ fieldName: "description", lang: "description", entireRow: true },
					{
						fieldName: "remarks",
						lang: "personal_memorandum",
						entireRow: true,
					},
				]
				this.apiCall = "get_followups_report"
				if (
					!this.permsService?.owner_has_users ||
					!this.permsService?.perms?.administrative
				) {
					this.fields = this.fields.filter((f) => f.fieldName != "assoc")
				}
				this.reportParamsObj.report_period_input = "this_month"
				this.breakInputs.set(["month", "year", "item", "no_breaks"])
				break
			case "followups_all_report":
				this.itemFuzzy.collection = ["patients"]
				this.itemFuzzy.lang = "patients"
				this.report_lang = "irs_journal_report"
				this.fields = [
					{ fieldName: "date", lang: "blank_value", isDate: true },
					{ fieldName: "item_name", lang: "name" },
					{ fieldName: "assoc", lang: "therapist" },
					{ fieldName: "arrived", lang: "arrived", actionType: "isCheckmark" },
					{ fieldName: "meetingtype_name", lang: "meetingtype", width: "20%" },
					{ fieldName: "paid_by", lang: "paid_by" },
					{
						fieldName: "price",
						lang: "charge",
						totals: true,
						isNumberField: true,
					},
					// {fieldName:'manual_price', lang: 'charge', totals: true, isNumberField: true},
					{
						fieldName: "total",
						lang: "paid",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "vat", lang: "vat", totals: true, isNumberField: true },
					{ lang: "finresource_num", actionType: "downloadInvoice" },
					{ lang: "email_invoice", actionType: "emailInvoice" },
					// {fieldName:'charged_manualy', lang: 'charged_manualy', actionType:"isCheckmark"},
					{ fieldName: "invoice_id", lang: "charged_manualy" },
					//{fieldName:'tarif_name', lang: 'tarif'},
					{
						fieldName: "sub_user_tarif",
						lang: "sub_user_tarif",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "deleted_remarks", lang: "remarks" },
				]

				if (
					!this.permsService?.owner_has_users ||
					!this.permsService?.perms?.administrative
				) {
					this.fields = this.fields.filter((f) => f.fieldName != "assoc")
					this.fields = this.fields.filter((f) => f.fieldName != "tarif_name")
					this.fields = this.fields.filter(
						(f) => f.fieldName != "sub_user_tarif"
					)
				}
				if (
					!this.permsService?.perms?.administrative &&
					!this.permsService?.perms?.clinic_financial
				) {
					this.fields = this.fields.filter((f) => f.fieldName != "paid_by")
					this.fields = this.fields.filter((f) => f.fieldName != "price")
					this.fields = this.fields.filter((f) => f.fieldName != "total")
					this.fields = this.fields.filter((f) => f.fieldName != "vat")
					this.fields = this.fields.filter((f) => f.lang != "finresource_num")
					this.fields = this.fields.filter((f) => f.lang != "email_invoice")
					this.fields = this.fields.filter((f) => f.fieldName != "invoice_id")
				}
				this.apiCall = "get_followups_all_report"
				this.reportParamsObj.report_period_input = "this_month"
				break
			case "followups_sub_user_report":
				this.fuzzyFields = [
					{
						fieldName: "item_id",
						lang: "therapists",
						collection: ["sub_users"],
					},
				]
				this.itemFuzzy = this.fuzzyFields.find(
					(it) => it.fieldName == "item_id"
				)
				this.report_lang = "followups_sub_user_report"
				this.fields = [
					{ fieldName: "date", lang: "blank_value", isDate: true },
					{ fieldName: "item_name", lang: "name" },
					{ fieldName: "assoc", lang: "therapist" },
					{ fieldName: "arrived", lang: "arrived", actionType: "isCheckmark" },
					{
						fieldName: "meetingtype_name",
						lang: "meetingtype",
						totals: true,
						addFunc: (row) => true,
					},
					{
						fieldName: "price",
						lang: "charge",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "price_patient",
						lang: "price_patient",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "price_payor",
						lang: "price_payor",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "tarif_name", lang: "tarif" },
					{
						fieldName: "tarif_percent",
						lang: "percent_for_calculation",
						isNumberField: true,
					},
					{
						fieldName: "sub_user_tarif",
						lang: "sub_user_tarif",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "sub_user_tarif_paid",
						lang: "sub_user_tarif_paid",
						totals: true,
						isNumberField: true,
					},
				]
				if (
					!this.permsService?.perms?.administrative &&
					!this.permsService?.perms?.clinic_financial
				) {
					this.fields = this.fields.filter((f) => f.fieldName != "price")
					this.fields = this.fields.filter(
						(f) => f.fieldName != "price_patient"
					)
					this.fields = this.fields.filter((f) => f.fieldName != "price_payor")
				}
				this.breakInputs.set(["month", "year", "no_breaks"])
				this.apiCall = "get_followups_sub_user_report" //"get_followup for sub user";

				this.reportParamsObj.report_period_input = "this_month"
				break

			case "invoices_sub_user_report":
				this.fuzzyFields = [
					{
						fieldName: "item_id",
						lang: "therapists",
						collection: ["sub_users"],
					},
				]
				this.itemFuzzy = this.fuzzyFields.find(
					(it) => it.fieldName == "item_id"
				)
				this.report_lang = "invoices_sub_user_report"
				this.fields = [
					{ fieldName: "date", lang: "date", isDate: true },
					{ fieldName: "item_name", lang: "name" },
					{ fieldName: "assoc", lang: "assoc" },
					{
						fieldName: "total",
						lang: "sum",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "vat",
						lang: "vat",
						totals: true,
						conditionalValue: false,
						isNumberField: true,
					},
					{
						fieldName: "totalMinusvat",
						lang: "totalMinusvat",
						totals: true,
						conditionalValue: false,
						isNumberField: true,
					},
					{ fieldName: "model_name", lang: "model_name" },
					{ lang: "finresource_num", actionType: "downloadInvoice" },
					{ lang: "email_invoice", actionType: "emailInvoice" },
					{
						fieldName: "sendgrid_status",
						lang: "sendgrid_status",
						actionType: "sendStatus",
					},
					{
						fieldName: "emails",
						lang: "sent_to",
						ngIfFunc: (reportParamsObj: reportParamsObj) => {
							return reportParamsObj?.showEmails
						},
					},
				]

				this.breakInputs.set(["month", "year", "item", "no_breaks"])
				this.apiCall = "get_invoices_sub_user_report" //"get_invoices for sub user";
				this.reportParamsObj.report_period_input = "this_month"
				break
			case "followups_sub_user_rent_report":
				this.fuzzyFields = [
					{
						fieldName: "item_id",
						lang: "therapists",
						collection: ["sub_users"],
					},
					//{ fieldName:'location_id', lang: 'locations', collection: ["locations"] },
				]
				this.itemFuzzy = this.fuzzyFields.find(
					(it) => it.fieldName == "item_id"
				)

				this.report_lang = "followups_sub_user_rent_report"
				this.fields = [
					{ fieldName: "date", lang: "blank_value", isDate: true, width: "5%" },
					{ fieldName: "item_name", lang: "name", width: "10%" },
					{ fieldName: "assoc", lang: "therapist", width: "10%" },
					{ fieldName: "location", lang: "location", width: "10%" },
					{
						fieldName: "arrived",
						lang: "arrived",
						actionType: "isCheckmark",
						width: "4%",
					},
					{ fieldName: "meetingtype_name", lang: "meetingtype", width: "10%" },
					{ fieldName: "time", lang: "time", width: "10%" },
					{ fieldName: "time_to", lang: "time_to", width: "10%" },
					{
						fieldName: "length",
						lang: "length",
						width: "4%",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "is_deleted", lang: "deleted", width: "5%" },
					{ fieldName: "deleted_remarks", lang: "remarks", width: "10%" },
					{ fieldName: "is_private", lang: "is_private", width: "4%" },
					{
						fieldName: "count_is_private_yes",
						lang: "count_is_private_yes",
						width: "4%",
						totals: true,
						addFunc: (row) => row.is_private_orig == "yes",
					},
					{
						fieldName: "count_is_private_no",
						lang: "count_is_private_no",
						width: "4%",
						totals: true,
						addFunc: (row) => row.is_private_orig == "no",
					},
					// { fieldName:'price', lang: 'charge', totals: true, isNumberField: true },
					// { fieldName:'price_patient', lang: 'price_patient', totals: true, isNumberField: true },
					// { fieldName:'price_payor', lang: 'price_payor', totals: true, isNumberField: true },
					// // { lang: 'finresource_num', actionType:"downloadInvoice" },
					// { fieldName:'sub_user_tarif', lang: 'sub_user_tarif', totals: true, isNumberField: true },
					// { fieldName:'sub_user_tarif_paid', lang: 'sub_user_tarif_paid', totals: true, isNumberField: true },
				]

				this.breakInputs.set(["month", "year", "item", "payor", "no_breaks"])
				this.apiCall = "get_followups_sub_user_rent_report" //"get_followup for sub user";
				this.reportParamsObj.report_period_input = "this_month"
				break

			case "debts_report":
				this.summarizedView = true

				this.report_lang = "debts_report"
				this.itemFuzzy.collection = ["patients"]
				this.itemFuzzy.lang = "patients"
				this.reportParamsObj.report_break_input = "item"

				this.fields = [
					{ fieldName: "date", lang: "blank_value", isDate: true },
					{ fieldName: "item_name", lang: "name" },
					{ fieldName: "assoc", lang: "therapist" },
					{ fieldName: "arrived", lang: "arrived", actionType: "isCheckmark" },
					{
						fieldName: "meetingtype_name",
						lang: "meetingtype",
						totals: true,
						addFunc: (row) => row.type == "followup",
					},
					{ fieldName: "paid_by", lang: "paid_by" },
					{
						fieldName: "price",
						lang: "charge",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "price_patient",
						lang: "price_patient",
						totals: true,
						isNumberField: true,
					},
					{
						fieldName: "price_payor",
						lang: "price_payor",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "payor_name", lang: "payor" },
					{
						fieldName: "total",
						lang: "paid",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "vat", lang: "vat", totals: true, isNumberField: true },
					{ fieldName: "paid_by_invoice", lang: "paid_by_invoice" },
					{ fieldName: "id", lang: "finresource_num" },
					{
						fieldName: "debtUntilDate",
						lang: "debtUntilDate",
						totals: true,
						to_date: true,
					},
					{ fieldName: "debtUntilNow", lang: "debtUntilNow", totals: true },
					{ lang: "proforma", actionType: "emailProforma" },
					{ lang: "send_proforma", actionType: "sendProforma" },
				]
				if (
					!this.permsService?.owner_has_users ||
					!this.permsService?.perms?.administrative
				) {
					this.fields = this.fields.filter((f) => f.fieldName != "assoc")
				}
				this.breakInputs.set(["month", "year", "item", "payor", "no_breaks"])
				this.apiCall = "get_followups_report"
				break
			case "debts_report2":
				this.itemFuzzy.collection = ["patients", "payors"]
				this.itemFuzzy.lang = "patient_or_payor"
				this.summarizedView = true
				this.modalWidth = "modal-1200"
				this.report_lang = "debts_report"
				this.reportParamsObj.report_break_input = "item"

				this.fields = [
					{ fieldName: "date", lang: "blank_value", isDate: true },
					{ fieldName: "display_name", lang: "name" },
					{
						fieldName: "price",
						lang: "charge",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "num", lang: "", totals: true, addFunc: (row) => true },
					{ lang: "email_proforma", actionType: "emailProforma" },
					{ lang: "send_proforma", actionType: "sendProforma" },
					{ lang: "invoice_short", actionType: "addInvoice" },
				]
				this.breakInputs.set(["item"])
				this.apiCall = "get_debt_items"
				break
			case "real_debt_report":
				this.summarizedView = false
				this.report_lang = "real_debt"
				this.itemFuzzy.collection = ["patients"]
				this.itemFuzzy.lang = "patients"
				this.reportParamsObj.report_break_input = "item"

				this.fields = [
					{ fieldName: "item_name", lang: "name" },
					{ fieldName: "debtUntilNow", lang: "debtUntilNow", totals: true },
				]
				this.apiCall = "get_real_debt"
				break

			case "proformas_report":
				this.report_lang = "proformas_report"
				this.fields = [
					{ fieldName: "item_name", lang: "name" },
					{
						fieldName: "total",
						lang: "sum",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "vat", lang: "vat", totals: true, isNumberField: true },
					{
						fieldName: "totalMinusvat",
						lang: "totalMinusvat",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "period", lang: "period" },
					{ fieldName: "paid_by_invoice", lang: "paid_by_invoice" },
					{ fieldName: "created_at", lang: "created_at", isDate: true },
					{ lang: "proforma_id", actionType: "downloadInvoice" },
					{
						fieldName: "sendgrid_status",
						lang: "sendgrid_status",
						actionType: "sendStatus",
					},
					{ lang: "email_invoice", actionType: "emailInvoice" },
				]
				this.apiCall = "get_proformas_report"
				break
			case "justinvoices_report":
				this.report_lang = "justinvoices_report"
				this.fields = [
					{ fieldName: "item_name", lang: "name" },
					{
						fieldName: "total",
						lang: "sum",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "vat", lang: "vat", totals: true, isNumberField: true },
					{
						fieldName: "totalMinusvat",
						lang: "totalMinusvat",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "period", lang: "period" },
					{ fieldName: "paid_by_invoice", lang: "paid_by_invoice" },
					{ fieldName: "created_at", lang: "created_at", isDate: true },
					{
						fieldName: "repayment_date",
						lang: "repayment_date",
						isDate: true,
						avoidFormat: true,
					},
					{ lang: "finresource_num", actionType: "downloadInvoice" },
					{
						fieldName: "sendgrid_status",
						lang: "sendgrid_status",
						actionType: "sendStatus",
					},
					{ lang: "email_invoice", actionType: "emailInvoice" },
				]
				this.apiCall = "get_justinvoices_report"
				break
			case "expenses_report":
				this.fuzzyFields = [
					{
						fieldName: "item_id",
						lang: "expensetypes",
						collection: ["expensetypes"],
					},
				]
				this.itemFuzzy = this.fuzzyFields.find(
					(it) => it.fieldName == "item_id"
				)

				this.report_lang = "expenses_report"
				this.fields = [
					{
						fieldName: "date",
						lang: "expense_date",
						isDate: true,
						width: "5%",
					},
					{ fieldName: "description", lang: "description", width: "9%" },
					{ fieldName: "expensetype_name", lang: "expensetype", width: "9%" },
					{
						fieldName: "sum",
						lang: "sum",
						totals: true,
						isNumberField: true,
						width: "9%",
					},
					{
						fieldName: "expense_without_vat",
						lang: "expense_without_vat",
						totals: true,
						isNumberField: true,
						width: "5%",
					},
					{
						fieldName: "expense_vat",
						lang: "vat",
						totals: true,
						isNumberField: true,
						width: "5%",
					},
					{
						fieldName: "expensetype_vat_percent",
						lang: "expensetype_vat_percent",
						width: "5%",
					},
					{
						fieldName: "expense_vat_recognized",
						lang: "vat_deductible",
						totals: true,
						isNumberField: true,
						width: "5%",
					},
					{ fieldName: "tax_percent", lang: "tax_percent", width: "5%" },
					{
						fieldName: "expense_recognized_for_tax",
						lang: "tax_deductible",
						totals: true,
						isNumberField: true,
						width: "5%",
					},
					{
						fieldName: "expense_recognized_for_tax2",
						lang: "tax_deductible2",
						totals: true,
						isNumberField: true,
						width: "5%",
					},
					{ fieldName: "supplier_name", lang: "supplier_name", width: "9%" },
					{ fieldName: "supplier_number", lang: "number", width: "9%" },
					{
						fieldName: "supplier_invoice",
						lang: "supplier_invoice",
						width: "5%",
					},
					{ fieldName: "created_at_render", lang: "created_at", width: "5%" },
				]
				this.apiCall = "get_expenses_report"
				this.breakInputs.set(["month", "year", "item", "no_breaks"])
				this.reportParamsObj.showByCreatedAt = this.showByCreatedAt
				break
			case "payorprices_report":
				this.fuzzyFields = [
					{
						fieldName: "item_id",
						lang: "meetingtype",
						collection: ["meetingtypes"],
					},
				]
				this.itemFuzzy = this.fuzzyFields.find(
					(it) => it.fieldName == "item_id"
				)

				this.report_lang = "payorprices"
				this.fields = [
					{ fieldName: "id", lang: "id", width: "5%" },
					{ fieldName: "payor_name", lang: "name", width: "10%" },
					{ fieldName: "meetingtype_name", lang: "meetingtype", width: "10%" },
					{
						fieldName: "price_payor",
						lang: "price_payor",
						totals: true,
						isNumberField: true,
						width: "10%",
					},
					{ fieldName: "unit", lang: "unit", width: "10%" },
					{ fieldName: "active", lang: "active", width: "10%" },
				]
				this.apiCall = "get_payorprices_report"
				this.breakInputs.set(["item", "no_breaks"])
				this.periodInputs = []
				this.modalWidth = "modal-full-width"
				this.dates_range = false
				break

			case "rent_report":
				this.fuzzyFields = [
					{ fieldName: "item_id", lang: "contacts", collection: ["contacts"] },
				]
				this.itemFuzzy = this.fuzzyFields.find(
					(it) => it.fieldName == "item_id"
				)

				this.report_lang = this.permsService.owner_has_users
					? "rent_report"
					: "contacts_meetings"
				this.fields = [
					{ fieldName: "id", lang: "id", width: "5%" },
					{ fieldName: "contact_name", lang: "name", width: "10%" },
					{ fieldName: "date", lang: "date", width: "10%", isDate: true },
					{ fieldName: "location", lang: "location", width: "10%" },
					{ fieldName: "price", lang: "price", width: "10%" },
					{ fieldName: "time", lang: "time", width: "10%" },
					{ fieldName: "time_to", lang: "time_to", width: "10%" },
					{
						fieldName: "length",
						lang: "length",
						width: "10%",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "is_deleted", lang: "deleted", width: "5%" },
					{ fieldName: "deleted_remarks", lang: "remarks", width: "15%" },
				]
				if (!this.permsService?.owner_has_users) {
					this.fields = this.fields.filter((f) => f.fieldName != "location")
				}
				if (this.permsService?.owner_has_users) {
					this.fields = this.fields.filter((f) => f.fieldName != "price")
				}
				this.apiCall = "get_fus_rent_report"
				this.breakInputs.set(["item", "no_breaks"])
				break
			case "locations_report":
				this.fuzzyFields = [
					{
						fieldName: "item_id",
						lang: "locations",
						collection: ["locations"],
					},
				]
				this.itemFuzzy = this.fuzzyFields.find(
					(it) => it.fieldName == "item_id"
				)

				this.report_lang = "locations_report"
				this.fields = [
					{ fieldName: "date", lang: "date", width: "10%", isDate: true },
					{ fieldName: "location", lang: "location", width: "10%" },
					{ fieldName: "time", lang: "time", width: "10%" },
					{ fieldName: "time_to", lang: "time_to", width: "10%" },
					{
						fieldName: "length",
						lang: "length",
						width: "10%",
						totals: true,
						isNumberField: true,
					},
					{ fieldName: "id", lang: "id", width: "5%" },
					{ fieldName: "name", lang: "name", width: "10%" },
				]
				this.apiCall = "get_fus_locations_report"
				this.breakInputs.set(["item", "no_breaks"])
				break
		}
		const visFieldsObj = this.cliniqData?.report_fields
		if (visFieldsObj && this.report_name in visFieldsObj) {
			this.visFields = visFieldsObj[this.report_name]
		} else {
			this.visFields = reportVisFields[this.report_name].reduce(
				(acc, item) => ({ ...acc, [item]: true }),
				{}
			)
		}

		if (this.inputRow) {
			this.filterFieldValue = this.inputRow?.id || 0
			this.filterFieldShown = this.inputRow?.name || ""
		}

		this.reportParamsObj.report_name = this.report_name
		if (this.reportParamsObj.report_period_input !== "date_range") {
			this.reportParamsObj.from_date = this.store.getDateStr()
			this.reportParamsObj.to_date = this.store.getDateStr(true)
		}
		this.updateDisplayDates()

		if (this.filterFieldName) {
			this.reportParamsObj[this.filterFieldName] = this.filterFieldValue
			this.reportParamsObj.item_type = this.item_type
		}

		this.getTableRows()
	}

	async updateVisFields() {
		if (!this.cliniqData.report_fields) {
			this.cliniqData.report_fields = {}
		}
		this.cliniqData.report_fields[this.report_name] = this.visFields
		const result: any = await this.apiService.post("update_configcliniq_data", {
			...this.cliniqData,
			update: "user",
		})
		if (result && !result?.error) {
			//success
			this.modalService.openToast(this.lang.getVal("updated_successfully")) //open toast with success message
			sessionStorage.setItem("cliniqData", JSON.stringify(result)) //update the config object in the sessionStorage
		} else {
			//fail
			this.modalService.openToast(this.lang.getVal(result?.error)) //open toast with fail message
		}
	}

	updateDisplayDates() {
		if (this.reportParamsObj.report_period_input == "date_range") {
			return
		}
		const [from, to] = this.store.getPriodFromTo(
			this.reportParamsObj.report_period_input
		)
		this.reportParamsObj.from_date = from
		this.reportParamsObj.to_date = to
		if (this.fromDate) {
			this.fromDate.refreshWithModel()
			this.toDate.refreshWithModel()
		}
	}

	onDateChange(fieldName: string) {
		this.store.dateFieldsInfluences(
			this.reportParamsObj,
			"from_date",
			"to_date",
			this.toDate
		)

		this.reportParamsObj.report_period_input = "date_range"
		this.updateDisplayDates()
		this.getTableRows()
	}

	changeBtn(fieldName: string, value: string) {
		if (fieldName == "report_break_input") {
			this.areConditionalColumnsVisible = value == "payment_method"
		}

		this.reportParamsObj[fieldName] = value
		this.updateDisplayDates()
		this.getTableRows()
	}

	onAcChoose(fieldName: string, retObj: any) {
		const itemFuzzy = this.fuzzyFields.find((it) => it.fieldName == "item_id")
		if (fieldName == "item_id") {
			this.reportParamsObj.item_id = 0
			this.reportParamsObj.item_type = ""
			this.itemName = ""

			// this.reportParamsObj.patient_id = 0;
			// this.reportParamsObj.payor_id = 0;
			// this.reportParamsObj.contact_id = 0;
			if (retObj?.id) {
				this.itemName = retObj?.name
				const className = retObj.typeClassName
				// const fieldName = className.substr(0, className.length - 1) + "_id";
				const fieldName = className.substr(0, className.length - 1)

				this.reportParamsObj.item_type = fieldName
				this.reportParamsObj.item_id = retObj.id
			}
		} else {
			this.reportParamsObj[fieldName] = retObj && retObj.id ? retObj.id : 0
		}

		this.getTableRows()
	}

	async getTableRows() {
		//COME BACK TO TYPE!!!!

		this.sortField = null
		this.sortIsAsc = false
		this.curShowToken = null
		//patient","payment_method","payor

		this.isLoading = true

		const res: any = await this.apiService.post(
			this.apiCall,
			this.reportParamsObj
		)

		if (this.report_name == "real_debt_report") {
			this.isLoading = false
			const rows = []
			const ids = Object.keys(res)
			ids.forEach((id) => {
				const patient = this.store.searchSiteDataItem(id, ["patients"])
				if (patient) {
					const row = {
						item_name: patient.name,
						debtUntilNow: this.numberFormat(res[id].debtUntilNow),
					}
					rows.push(row)
				}
			})

			this.tableRows = rows
			return
		}

		this.apiService.decryptInCollection(res)
		this.isLoading = false
		let disaplyArray: any[] = []
		let subTotalInfo: any = {
			month: -1,
			year: -1,
			item_id: -1,
			payment_method: "",
			payor_id: -1,
			meetingtype_id: -1,
		}

		this.totals = {}
		let objSummarizer = {}
		let arrFieldsToFormat = []
		this.fields.forEach((field) => {
			if (field.totals) {
				this.totals[field.fieldName] = 0
				objSummarizer[field.fieldName] = 0
			}
			if (field.isNumberField) {
				arrFieldsToFormat.push(field.fieldName)
			}
		})

		this.tableRows = res

		if (this.report_name == "rent_report") {
			this.tableRows.forEach((row) => {
				row.contact_name =
					this.store.searchSiteDataItem(row.contact_id, ["contacts"])?.name ||
					""
				row.location_name =
					this.store.searchSiteDataItem(row.contact_id, ["locations"])?.name ||
					""
			})
		}
		//if breaks are item  - make sure  all rows that are "same" group are next to each other
		if (this.reportParamsObj.report_break_input == "item") {
			this.tableRows.sort((a, b) => {
				if (a.item_type != b.item_type) {
					return a.item_type > b.item_type ? 1 : -1
				}
				if (a.item_id != b.item_id) {
					return a.item_id > b.item_id ? 1 : -1
				}
				return a.item_name > b.item_name ? 1 : -1
			})
		}
		if (this.reportParamsObj.report_break_input == "meetingtype") {
			this.tableRows = this.tableRows.filter(
				(row) => !["", " ", -1, "-1"].includes(row?.meetingtype_id)
			)

			this.tableRows.sort((a, b) => {
				// return (a.item_type == b.item_type ? (a.item_id - b.item_id) : (a.item_type > b.item_type ? 1 : -1));
				return a.meetingtype_name > b.meetingtype_name ? 1 : -1
			})
		}
		//if breaks are payment_method  - make sure  all rows that are "same" group are next to each other
		if (this.reportParamsObj.report_break_input == "payment_method") {
			this.tableRows.sort((a, b) => {
				return a.paymentmethod == b.paymentmethod
					? new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
					: a.paymentmethod > b.paymentmethod
						? 1
						: -1
			})
		}

		this.tableRows.forEach((row, index) => {
			//loop over all rows
			// if(row.type && row.type=="debt_line"){
			// 	return;
			// }
			this.fields.forEach((field) => {
				if (field.isDate) {
					row[field.fieldName + "_exVal"] = new Date(row[field.fieldName])
				} else if (field.isNumberField) {
					row[field.fieldName + "_exVal"] = Number(row[field.fieldName])
				}
			})

			if (this.dateNeedFormatting) {
				//manage month/year formats etc
				//date-month-year
				let momDate = moment.utc(row.date || row.created_at)

				row.month = momDate.month() + 1
				row.year = momDate.year()
				this.fields.forEach((field) => {
					if (field.isDate && !field.avoidFormat) {
						row[field.fieldName] = momDate.format(
							ConfigDefinitions.momentDateFormat
						)
					}
				})
			} else {
				let dateSplit = row.date.split("-")
				row.month = dateSplit[1]
				row.year = dateSplit[0]
			}

			this.fields.forEach((field) => {
				const name = field.fieldName
				if (field.isDate && row[name]) {
					// let dateSplit = (row[name].split('-'));	//assumed Y-
					row[name] = this.store.getMomentDisplay(row[name])
				}
			})

			let rowObjectToCompareToSubTotal: any = {
				month: row.month,
				year: row.year,
				item_id: row.item_id,
				meetingtype_id: row.meetingtype_id,
				meetingtype_name: row.meetingtype_name,
				item_type: row.item_type,
				payment_method: row?.payment_method,
				payor_id: row.payor_id,
				item_name: row?.item_name || "",
				payor_name: row?.payor_name || "",
			}

			let subTotalInfoObj = this.getSubTotalInfo(
				subTotalInfo,
				rowObjectToCompareToSubTotal
			)

			if (subTotalInfoObj.changeHappened) {
				//EITHER initial reset OR subtotal row
				if (
					!index &&
					this.hasBreakHeaders &&
					this.reportParamsObj.report_break_input
				) {
					const alt = this.getSubTotalInfo(
						rowObjectToCompareToSubTotal,
						rowObjectToCompareToSubTotal
					)
					let newRow: any = {
						name: alt.subTotalName,
						isBreakHeader: true,
					}
					disaplyArray.push(newRow)
				}

				if (index) {
					//ONLY if subtotal row (NOT FIRST ROW (meaning not initial reset))
					if (this.hasBreakHeaders) {
						const alt = this.getSubTotalInfo(
							rowObjectToCompareToSubTotal,
							rowObjectToCompareToSubTotal
						)
						let newRow: any = {
							name: alt.subTotalName,
							isBreakHeader: true,
						}
						disaplyArray.push(newRow)
					} else {
						let newRow: any = {
							name: subTotalInfoObj.subTotalName,
							isSubTotal: true,
						}
						Object.keys(this.totals).forEach((totFieldName) => {
							newRow[totFieldName] = Number.isNaN(objSummarizer[totFieldName])
								? 0
								: objSummarizer[totFieldName]
						})
						this.debtReportTotals(newRow, subTotalInfo)

						arrFieldsToFormat.forEach(
							(fieldName) =>
								(newRow[fieldName] = this.numberFormat(newRow[fieldName]))
						)

						this.addShowTokenToRow(newRow, subTotalInfoObj)

						disaplyArray.push(newRow)
					}
				}

				objSummarizer = {}
				Object.keys(this.totals).forEach((totFieldName) => {
					objSummarizer[totFieldName] = 0
				})
				subTotalInfo = rowObjectToCompareToSubTotal
			}

			Object.keys(this.totals).forEach((totFieldName) => {
				let numToAdd = row[totFieldName]
				const field = this.fields.find((it) => it.fieldName == totFieldName)
				if (field?.addFunc) {
					numToAdd = field.addFunc(row) ? 1 : 0
				}

				objSummarizer[totFieldName] += +numToAdd
				this.totals[totFieldName] += +numToAdd
			})

			//attach showToken
			this.addShowTokenToRow(row)

			// objSummarizer.total+=+row.total;
			// objSummarizer.vat+=+row.vat;

			// this.totals.total+=+row.total;
			// this.totals.vat+=+row.vat;
			arrFieldsToFormat.forEach(
				(fieldName) => (row[fieldName] = this.numberFormat(row[fieldName]))
			)
			disaplyArray.push(row)
		})

		if (
			this.tableRows.length &&
			this.reportParamsObj.report_break_input != "no_breaks" &&
			!this.hasBreakHeaders
		) {
			//find subtotal after iterated all rows
			let subTotalInfoObj = this.getSubTotalInfo(subTotalInfo)

			let newRow: any = { name: subTotalInfoObj.subTotalName, isSubTotal: true }
			Object.keys(this.totals).forEach((totFieldName) => {
				newRow[totFieldName] = Number.isNaN(objSummarizer[totFieldName])
					? 0
					: objSummarizer[totFieldName]
			})

			this.debtReportTotals(newRow, subTotalInfo)
			this.addShowTokenToRow(newRow, subTotalInfoObj)

			arrFieldsToFormat.forEach(
				(fieldName) =>
					(newRow[fieldName] = this.numberFormat(newRow[fieldName]))
			)
			disaplyArray.push(newRow)
		}
		this.tableRows = disaplyArray
		if (this.report_name == "debts_report") {
			this.getRealDebt()
		}

		Object.keys(this.totals).forEach((key) => {
			if (Number.isNaN(this.totals[key])) {
				this.totals[key] = 0
			} else {
				const field = this.fields.find((it) => it.fieldName == key)
				if (!field?.addFunc) {
					this.totals[key] = this.numberFormat(this.totals[key])
				}

				// switch(key){
				//   case "meetingtype_name":
				//   break;
				//   default:
				//     this.totals[key] =  this.numberFormat(this.totals[key]);
				// }
			}
		})

		if (this.report_name == "debts_report2") {
			this.sort(this.fields.find((it) => it.fieldName == "date"))
			this.tableRows
				.filter((r) => r.isSubTotal)
				.forEach((r) => {
					const type = r.item_type + "s"
					const person = this.store.searchSiteDataItem(r.item_id, [type])
				})
		}
	}
	fromFormat(n: string) {
		return Number(n.replaceAll(",", ""))
	}
	debtReportTotals(newRow: any, inputRow: any) {
		if (["debts_report", "debts_report2"].includes(this.report_name)) {
			if (this.reportParamsObj.report_break_input == "item") {
				newRow.item_id = inputRow.item_id
				newRow.item_type = inputRow.item_type
			}
		}
	}
	async getRealDebt() {
		const res: any = await this.apiService.post(
			"get_real_debt",
			this.reportParamsObj
		)
		if (this.reportParamsObj.report_break_input == "item") {
			this.totals.debtUntilDate = 0
			this.totals.debtUntilNow = 0
			Object.keys(res).forEach((patient_id) => {
				const obj = res[patient_id]
				const row = this.tableRows.find(
					(r) => r.isSubTotal && r?.item_id == patient_id
				)
				if (row) {
					row.debtUntilDate = this.numberFormat(obj.debtUntilDate)
					this.totals.debtUntilDate += +obj.debtUntilDate
					row.debtUntilNow = this.numberFormat(obj.debtUntilNow)
					this.totals.debtUntilNow += +obj.debtUntilNow
				}
			})
		}
		this.totals.debtUntilDate = this.numberFormat(this.totals.debtUntilDate)
		this.totals.debtUntilNow = this.numberFormat(this.totals.debtUntilNow)
	}
	monthYearFormat(month: string, year: any) {
		if (year === -1) {
			return ""
		}
		const monthNum = Number(month)
		year = year.toString().substr(-2)
		return String(monthNum) + "." + year
	}
	addShowTokenToRow(row: any, inputRow: any = null) {
		if (!inputRow) {
			inputRow = row
		}
		if (inputRow?.showToken) {
			row.showToken = inputRow.showToken
			return
		}

		switch (this.reportParamsObj.report_break_input) {
			case "month":
				row.showToken = this.monthYearFormat(inputRow.month, inputRow.year)
				break
			case "year":
				row.showToken = inputRow.year
				break
			case "type":
				//
				break
			case "item":
				row.showToken = inputRow?.item_type + "-" + inputRow?.item_id
				break
			case "payment_method":
				row.showToken = inputRow.payment_method
				break
			case "payor":
				row.showToken = inputRow.payor_id
				break
			case "meetingtype":
				row.showToken = inputRow.meetingtype_id
				break
		}
	}
	rowClick(row: any) {
		if (!row?.isSubTotal) {
			return
		}
		this.curShowToken =
			row.showToken == this.curShowToken ? null : row.showToken
	}

	getSubTotalInfo(curRowPeriod: any, rowPeriod: any = {}) {
		let infoObj = {
			changeHappened: false,
			subTotalName: "",
			showToken: "",
			item_id: 0,
			item_type: "",
		}

		switch (this.reportParamsObj.report_break_input) {
			case "month":
				infoObj.changeHappened =
					curRowPeriod.month != rowPeriod.month ||
					curRowPeriod.year != rowPeriod.year
				infoObj.subTotalName = this.monthYearFormat(
					curRowPeriod.month,
					curRowPeriod.year
				)
				break
			case "year":
				infoObj.changeHappened = curRowPeriod.year != rowPeriod.year
				infoObj.subTotalName = curRowPeriod.year
				break
			case "type":
				//
				break
			case "item":
				infoObj.changeHappened =
					curRowPeriod.item_type != rowPeriod.item_type ||
					curRowPeriod.item_id != rowPeriod.item_id
				infoObj.subTotalName = curRowPeriod.item_name
				infoObj.item_id = curRowPeriod.item_id
				infoObj.item_type = curRowPeriod.item_type
				infoObj.showToken = curRowPeriod.item_type + "-" + curRowPeriod.item_id
				break
			case "payment_method":
				infoObj.changeHappened =
					curRowPeriod.payment_method != rowPeriod.payment_method
				infoObj.subTotalName = curRowPeriod.payment_method
				break
			case "payor":
				infoObj.changeHappened = curRowPeriod.payor_id != rowPeriod.payor_id
				infoObj.subTotalName = curRowPeriod.payor_name
				infoObj.showToken = curRowPeriod.payor_id
				break
			case "meetingtype":
				infoObj.changeHappened =
					curRowPeriod.meetingtype_id != rowPeriod.meetingtype_id
				infoObj.subTotalName = curRowPeriod.meetingtype_name
				infoObj.showToken = curRowPeriod.meetingtype_id
				break
		}
		if (!infoObj.showToken) {
			infoObj.showToken = infoObj.subTotalName
		}
		return infoObj
	}

	numberFormat(num: number) {
		if (num == 0) {
			return ""
		}
		return this.store.numberFormat(num)
	}

	async downloadReport() {
		if (this.report_name === "debts_report2") {
			return this.exportDebtItems()
		}

		//this.reportParamsObj.report_name | langVal}} +'-'+this.reportParamsObj.from_date | dateFormat+'-'+this.reportParamsObj.to_date | dateFormat +".xlsx"
		const date_from = moment
			.utc(this.reportParamsObj.from_date)
			.format(ConfigDefinitions.momentDateDisplay)
		const date_to = moment
			.utc(this.reportParamsObj.to_date)
			.format(ConfigDefinitions.momentDateDisplay)
		const reportName =
			this.report_lang + "-" + date_from + "-" + date_to + ".xlsx"
		this.store.downloadToastFunc(async () => {
			const res: any = await this.apiService.download(this.apiCall, {
				...this.reportParamsObj,
				dlExcel: true,
			})
			this.apiService.downloadFile(res, reportName)
		})
	}

	async sendPdf() {
		const arr: any = await this.modalService.openMulti("gen-table-display", {
			tableName: "contactways",
			filterField: "patient_id",
			filterFieldValue: this.reportParamsObj.item_id,
			fieldNameInItemToDisplay: "contactway",
			isCheckItems: true,
			filterFieldApiObject: { contactway_identifier: "email" },
		})
		if (arr && arr.length) {
			const obj = {
				...this.reportParamsObj,
				sendPdf: true,
				emails: arr.map((row) => ({ email: row.contactway })),
			}
			this.isSendingPdf = true
			await this.apiService.post("email_report_pdf", obj)
			this.isSendingPdf = false
			this.modalService.openToast(this.lang.getVal("sent_successfully"))
		}
	}

	async downloadInvoice(
		row: any,
		arrRows: any[] = null,
		forceByEmail: boolean = false
	) {
		let type = row.model_name //  "invoice";
		if (this.report_name == "justinvoices_report") {
			type = "justinvoice"
		}
		if (this.report_name == "proformas_report") {
			type = "proforma"
		}

		let obj: any = { id: row.id }
		if (forceByEmail) {
			obj.by_email = "yes"
		}
		if (arrRows) {
			obj.emails_list = JSON.stringify(
				arrRows.map((row) => ({
					email: row.contactway,
					description: row.description,
				}))
			)
			obj.by_email = "yes"
		}
		// if (row.patient_id) { obj.patient_id = row.patient_id }
		// if (row.payor_id) { obj.payor_id = row.payor_id }
		// if (row.contact_id) { obj.contact_id = row.contact_id }
		// row.downloadSpin = true;
		// this.apiService.print_oneResourcePdf(type, obj).subscribe((res: any) => {
		// 	row.downloadSpin = false;
		// 	this.apiService.downloadFile(res, `${type}_${row.id}_copy.pdf`);
		// });

		const sendObj: any = { id: row.id, doctype: type } //,headture_id:this.headtureRow.id

		if (forceByEmail) {
			sendObj.by_email = "yes"
		}
		if (arrRows) {
			sendObj.emails_list = JSON.stringify(
				arrRows.map((row) => ({
					email: row.contactway,
					description: row.description,
				}))
			)
			sendObj.by_email = "yes"
		}

		row.downloadSpin = true
		this.store.downloadToastFunc(async () => {
			const res = await this.apiService.download(
				"print_make_finresource",
				sendObj
			)
			row.downloadSpin = false
			if (!res?.size) {
				return this.store.downloadFailedModal()
			}
			this.apiService.downloadFile(res, `${type}_${row.id}_copy.pdf`)
		})
	}

	async openContactwaysModal(row: any) {
		if (row?.item_type == "user") {
			this.downloadInvoice(row, null, true)

			return
		}

		let fieldName = row.item_type + "_id"
		// if (row.patient_id) { fieldName = "patient_id" }
		// if (row.payor_id) { fieldName = "payor_id" }
		// if (row.contact_id) { fieldName = "contact_id" }

		this.curRow = row
		const arr: any = await this.modalService.openMulti("gen-table-display", {
			tableName: "contactways",
			filterField: fieldName,
			filterFieldValue: row.item_id,
			fieldNameInItemToDisplay: "contactway",
			isCheckItems: true,
			...this.store.phoneEmailValidationAttrs(),
		})
		if (arr && arr.length) {
			this.downloadInvoice(this.curRow, arr)
			this.curRow = null
		}
	}

	async addProforma(row: any) {
		// if (row.item_type!="patient") {return;}
		if (row.debtUntilNow == 0 && this.report_name == "debts_report") {
			return
		}
		let description = ""
		// row.item_type = "patient";
		//if (row?.item_type== "patient") {	//if personType is patient, create a more specific description
		description =
			row?.name +
			this.store.getPatientAndMaybeIdNumber(row?.item_id, true) +
			"-" +
			this.lang.getVal("treatment")
		//}
		await this.modalService.openMulti("add-invoice", {
			//open the modal with fields relevant to this personType
			description,
			doctype: "proforma",
			paid_by: row?.name,
			is_withholding_tax: row?.item_type.is_withholding_tax,
			withholding_tax_percent: row?.item_type.withholding_tax_percent,
			for: row?.name,
			resource: row?.item_type,
			resourceId: row?.item_id,
		})
	}
	async addInvoice(row: any) {
		if (row.debtUntilNow == 0 && this.report_name == "debts_report") {
			return
		}
		let description = ""
		description =
			row?.name +
			this.store.getPatientAndMaybeIdNumber(row?.item_id, true) +
			"-" +
			this.lang.getVal("treatment")
		//}
		await this.modalService.openMulti("add-invoice", {
			//open the modal with fields relevant to this personType
			description,
			doctype: "invoice",
			paid_by: row?.name,
			is_withholding_tax: row?.item_type.is_withholding_tax,
			withholding_tax_percent: row?.item_type.withholding_tax_percent,
			for: row?.name,
			resource: row?.item_type,
			resourceId: row?.item_id,
		})
	}
	async sendProforma(row: any) {
		const patient_id = row.item_id
		row.sendProformaSpin = true
		const patient = await this.store.getPatient(patient_id)
		await this.store.sendProforma(patient)
		row.sendProformaSpin = false
	}

	async openCreditModal(row: any) {
		this.curRow = row
		this.curRow.doctype = this.curRow.model_name
		await this.modalService.openMulti("finresource-credit", {
			objectRow: { ...row },
			doctype: "admininvoice",
		})
	}
	getCssForPrintEtc() {
		return `<style type='text/css'>${this.store.getPrintStyle()}</style>`
	}

	getHtmlForPrintEtc(withTheadPre: boolean = true) {
		const cliniqData = this.store.getCliniqDataOrExit()

		let html = "</br></br>"
		html += document.getElementById("section-to-print").innerHTML
		html = this.store.processHtmlPreDl(html)
		html = html.replace(/<thead\s*>/g, "<thead>")

		let periodRange = document.getElementById("period-range").innerHTML
		periodRange = this.store.processHtmlPreDl(periodRange)
		let vat_number = cliniqData.vat_number ? cliniqData.vat_number : ""
		let tax_account_type = cliniqData.tax_account_type
			? this.lang.getVal(cliniqData.tax_account_type)
			: ""
		let title = cliniqData.title ? cliniqData.title : ""

		if (!withTheadPre) {
			return html
		}

		const theadPre = `
			<tr>
				<th colspan="99999">
					<p style="text-align: center;"  class="header" >${this.lang.getVal("medical_conf")}</p>
					${periodRange}
					<h3><span>${title}</span>
						<span>${cliniqData.name}</span>
						<span>${tax_account_type}</span>
						<span>${vat_number}</span>
					</h3>
          ${this.itemName ? `<h3>${this.itemName}</h3>` : ""}
				</th>
			</tr>
		`
		html = html.replace("<thead>", `<thead>${theadPre}`)

		return html
	}

	async print() {
		this.store.printWindow(`
		<html>
    ${this.getCssForPrintEtc()}
		<body onload="window.print();window.onafterprint=()=>window.close();" style="direction:rtl">

		${this.getHtmlForPrintEtc()}
		</body>
		</html>`)
	}
	async addDocument() {
		if (this.reportParamsObj?.item_type != "patient") {
			this.modalService.openToast(this.lang.getVal("select_a_patient"))
			return
		}
		const patient_id = this.reportParamsObj.item_id
		const patient = await this.store.getPatient(patient_id)

		// let html=this.getCssForPrintEtc()+this.getHtmlForPrintEtc();
		let html = this.getHtmlForPrintEtc(false)
		html = this.store.processHtmlPreDl(html)
		//remove print_hidden elements
		//<th blab blab hlba class="sdfds sdffds print_hidden" gfdgdf> <button>dfsfsd <span>fgfdg</span></button></th><th>fsdfdsffsdf</th>
		let pos = html.indexOf("print_hidden")
		while (pos != -1) {
			//find prev element
			const openTagPos = html.substring(0, pos).lastIndexOf("<")
			if (openTagPos == -1) {
				this.modalService.openToast(this.lang.getVal("invalid_text"))
				break
			}
			const nextSpacePos = html.indexOf(" ", openTagPos)
			if (nextSpacePos == -1) {
				this.modalService.openToast(this.lang.getVal("invalid_text"))
				break
			}
			const tagName = html.substring(openTagPos + 1, nextSpacePos)
			const closingTagString = "</" + tagName + ">"
			const closingTagPos = html.indexOf(closingTagString, openTagPos)
			if (closingTagPos == -1) {
				this.modalService.openToast(this.lang.getVal("invalid_text"))
				break
			}
			const endOfClosingTagPos = closingTagPos + closingTagString.length
			html = html.substring(0, openTagPos) + html.substring(endOfClosingTagPos)
			pos = html.indexOf("print_hidden")
		}

		;["table", "thead", "tbody", "tr", "td", "th"].forEach((tag) => {
			let re = new RegExp("</" + tag + "[\s]*>", "g")
			html = html.replace(re, "</" + tag + ">")
			re = new RegExp("<" + tag + " [^>]*>", "g")
			html = html.replace(re, "<" + tag + ">")
		})
		;["th", "td"].forEach((tag) => {
			html = html
				.split(`<${tag}>`)
				.map((it, pos) => {
					if (!pos) {
						return it
					}
					const r = it.split(`</${tag}>`)
					return `${this.store.strip_tags(r[0]).trim()}</${tag}>${r[1]}`
				})
				.join(`<${tag}>`)
		})

		html = html.replace("<table>", "<table class='planted-tbl'>")

		this.modalService.openMulti("add-document", {
			patient_id: patient.id,
			title:
				patient.name +
				" " +
				(patient.id_number
					? this.lang.getVal("id_number") + " " + patient.id_number
					: ""),
			recipient: patient.name,
			resource: "patient",
			resourceId: patient.id,
			preText: html,
		})
	}

	sort(fieldObj: any = null) {
		if (
			this.reportParamsObj.report_break_input == "item" &&
			fieldObj.fieldName == "item_name"
		) {
			return
		}

		this.sortIsAsc =
			this.sortField == fieldObj.fieldName ? !this.sortIsAsc : false

		if (this.reportParamsObj.report_break_input == "no_breaks") {
			this.innerSort(this.tableRows, fieldObj)
		} else {
			let collectArr = []
			let resArr = []
			let breakHeaderRow = null
			this.tableRows.forEach((row) => {
				if (row.isBreakHeader) {
					if (collectArr.length) {
						this.innerSort(collectArr, fieldObj)
						resArr.push(breakHeaderRow, ...collectArr)
						collectArr = []
					}
					breakHeaderRow = row
				} else if (row.isSubTotal) {
					this.innerSort(collectArr, fieldObj)
					resArr.push(...collectArr, row)
					collectArr = []
				} else {
					collectArr.push(row)
				}
			})
			if (this.hasBreakHeaders && collectArr.length) {
				this.innerSort(collectArr, fieldObj)
				resArr.push(breakHeaderRow, ...collectArr)
			}
			this.tableRows = [...resArr]
		}
	}

	innerSort(arr: any[], fieldObj: any = null) {
		const fieldName = fieldObj.fieldName
		this.sortField = fieldName
		const factor = this.sortIsAsc ? 1 : -1

		arr.sort((a, b) => {
			if (fieldObj.isDate || fieldObj.isNumberField) {
				return (b[fieldName + "_exVal"] - a[fieldName + "_exVal"]) * factor
			}
			// else if(fieldObj.isNumberField){

			// }
			else {
				if (a[fieldName] === undefined) {
					return 1
				}
				if (b[fieldName] === undefined) {
					return -1
				}
				let ret = b[fieldName] > a[fieldName] ? 1 : -1
				return ret * factor
			}
		})
		return arr
	}

	changeReport(name: string) {
		this.report_name = name
		this.ngOnInit()
	}
	chooseTags(tagObjs: any[], isUser: boolean = false) {
		const fieldName = isUser ? "user_tag_ids" : "location_tag_ids"
		this.reportParamsObj[fieldName] = []
		if (tagObjs?.length) {
			this.reportParamsObj[fieldName] = tagObjs.map((it) => Number(it.id))
		}
		this.getTableRows()
	}
	exportDebtItems() {
		const exportRows = []
		exportRows.push([this.lang.getVal("name"), this.lang.getVal("debt")])
		const rows = this.tableRows
			.filter((row) => row?.isSubTotal)
			.map((row) => {
				return [row.name.replaceAll(",", ""), row.price.replaceAll(",", "")]
			})
		exportRows.push(...rows)
		const csvData = exportRows.map((row) => row.join(",")).join("\n")
		this.store.downloadToastFunc(async () => {
			const res: any = await this.apiService.download("export_to_xlsx", {
				csvData,
			})
			this.apiService.downloadFile(res, "export.xlsx")
		})
	}
	openDebtPatients() {
		this.modalService.openMulti("debt-patients")
	}
}
